import DuraflowCategoryPage from '@/pages/equipamentos-e-componentes/components/DuraflowCategoryPage';
import useSeo from '@/hooks/useSeo';

export default function ManometrosPage() {
  useSeo({
    title: 'Manômetros e Medidores Industriais | Duraflow',
    description: 'Manômetros analógicos e digitais, medidores de vazão, termômetros e indicadores de nível para monitoramento de sistemas hidráulicos.',
    keywords: 'manômetros hidráulicos, medidores de vazão, instrumentos de medição, componentes hidráulicos, DURAFLOW, Grupo Pilar',
    canonical: 'https://www.pilarmanutencao.com.br/manometros-medidores',
    ogUrl: 'https://www.pilarmanutencao.com.br/manometros-medidores',
    ogImage: '/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANOMETROS-E-MEDIDORES/CARD/MANOMETROS-E-MEDIDORES.webp',
  });

  return (
    <DuraflowCategoryPage
      title="Manômetros e Medidores"
      subtitle="Instrumentos de medição de pressão, temperatura, vazão e nível para monitoramento preciso e seguro de sistemas hidráulicos."
      heroImage="/images/EQUIPAMENTOS-E-COMPONENTES/NOSSOS-PRODUTOS/MANOMETROS-E-MEDIDORES/HERO/HERO-MANOMETROS-E-MEDIDORES.webp"
      heroImageAlt="Manômetros e medidores industriais de pressão"
      description="Os instrumentos de medição DURAFLOW permitem o monitoramento contínuo e preciso dos parâmetros operacionais de sistemas hidráulicos. Manômetros, termômetros, medidores de vazão e indicadores de nível são fundamentais para a manutenção preventiva, diagnóstico de falhas e operação segura de equipamentos hidráulicos."
      applications={[
        'Monitoramento de centrais hidráulicas',
        'Diagnóstico de pressão em campo',
        'Calibração de sistemas hidráulicos',
        'Controle de processos industriais',
        'Manutenção preventiva programada',
        'Testes de estanqueidade e performance',
      ]}
      types={[
        {
          title: 'Manômetros Analógicos',
          description:
            'Manômetros Bourdon com caixa em aço inox ou ABS, com escalas em bar, psi, kgf/cm² e MPa para leitura direta da pressão do sistema.',
        },
        {
          title: 'Manômetros Digitais',
          description:
            'Manômetros digitais com display LCD, alta precisão, função de pico e saída elétrica para integração com sistemas de automação.',
        },
        {
          title: 'Medidores de Vazão',
          description:
            'Medidores de vazão tipo rotâmetro, turbina, engrenagem e eletromagnético para medição precisa do fluxo de óleo hidráulico.',
        },
        {
          title: 'Termômetros Industriais',
          description:
            'Termômetros bimetálicos e digitais com sonda para medição da temperatura do óleo, prevenindo degradação e perda de viscosidade.',
        },
        {
          title: 'Indicadores de Nível',
          description:
            'Visores de nível, indicadores elétricos e flutuadores para controle do volume de óleo no reservatório e prevenção de sucção a seco.',
        },
        {
          title: 'Acessórios de Instrumentação',
          description:
            'Amortecedores de pulso, sifões, válvulas de agulha, conexões e tubulação para instalação segura e precisa dos instrumentos.',
        },
      ]}
      differentials={[
        'Instrumentos calibrados com certificado rastreável às normas técnicas brasileiras',
        'Amplo estoque de manômetros com escalas e conexões das bitolas mais utilizadas',
        'Serviço de calibração periódica de manômetros e instrumentos de medição',
        'Medidores compatíveis com óleos hidráulicos, lubrificantes e fluidos industriais',
        'Suporte técnico para instalação correta e proteção contra sobrecarga de instrumentos',
      ]}
    />
  );
}